import React from 'react'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import LRTableBodyUI from '../../../widgets/layout/LRTableBodyUI'
import LRTableRowUI from '../../../widgets/layout/LRTableRowUI'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'
import LoanPropertyUpdateModalSF from './util/LoanPropertyUpdateModalSF'

const MonitoringPropertyListUI = ({context, propertyList, errorList, loan,
    // modes
    updateMode, selectedProperty,
    // event handlers
    onRefreshClick, onUpdateClick, onCancelClick, onUpdate
  }) =>
  <div className='su_props'>
    <LRTableActionsUI location='top'
      left={
        <span className='g_flex_left g_flex_h'>
          <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
          <span className='g_m_left_100 g_large'><b></b></span>
        </span>
      }
      right={<span />}
    />

    {
      !propertyList &&
      <SpinnerComponentUI />
    }
    <LRTableBodyUI>
      {
        propertyList && propertyList.map((property, i) =>
          <LRTableRowUI key={i}
            context={context}
            left={<RowLeftUI context={context} property={property} />}
            right={<RowRightUI property={property} onUpdateClick={onUpdateClick} />}
          />
        )
      }
    </LRTableBodyUI>

    <LoanPropertyUpdateModalSF
      context={context}
      errorList={errorList}
      updateMode={updateMode}
      onCancelClick={onCancelClick}
      selectedProperty={selectedProperty}
      onUpdate={onUpdate}
      loan={loan}
    />
  </div>

  const RowLeftUI = ({context, property}) =>
    <span className='g_no_wrap'>{/*{property.sequence}: */}{property.propertyName}
      {/*<span className='g_muted g_m_left_100'>loanProperties.{property.propertyCode}</span>*/}
    </span>

  const RowRightUI = ({property, onUpdateClick}) =>
    <div className='g_flex_h'>
      <span className={property.propertyValue === 'na' && 'g_muted'}>
        {(() => {
          switch (property.propertyValue) {
            // Income
            case 'complied':
            return 'Complied'
            case 'not_complied':
            return 'Not complied'
            case 'na':
            return 'Not applicable'
            default:
              return property.propertyValue
          }
        })()}
      </span>
      <span className='icon icon-pencil g_link_2 g_m_left_50'
        data-property={property.propertyCode} onClick={onUpdateClick} />
    </div>


export default MonitoringPropertyListUI
